<template>
  <div class="comments-neurohub card mt-2">
    <div class="card-header">
      <div class="text-center"><h4 class="card-title">Commenti</h4></div>
    </div>
    <div class="card-body">
      <div
        class="review"
        style="border-bottom: 0px"
        v-for="(comment, index) in comments"
        :key="index"
      >
        <div class="row no-gutters">
          <div :class="classComment.name">
            <h4>
              <a href="#">{{ comment.full_name }}</a>
            </h4>
          </div>
          <div :class="classComment.text">
            <div class="review-content">
              <p>{{ comment.text }}</p>
            </div>

            <div class="review-action row">
              <!-- Regola per bloccare i non utenti-->
              <button
                class="btn btn-link"
                @click="openModalResponse(comment.id)"
                v-if="comment_permission && model != 'meeting-old'"
              >
                <i class="las la-reply"></i>Rispondi
              </button>
              <div v-if="comment.attachments.length > 0">
                |
                <button
                  class="btn btn-link"
                  title="view-attachments"
                  @click="showModalAttachments(comment.id)"
                >
                  Vedi gli allegati
                </button>
              </div>
            </div>
            <div v-if="comment.responses.length > 0">
              <div
                class="review"
                style="border-bottom: 0px"
                v-for="response in comment.responses"
                :key="response.full_name"
              >
                <div class="row no-gutters pt-2">
                  <div class="col-3">
                    <h4>
                      <a href="#">{{ response.full_name }}</a>
                    </h4>
                  </div>
                  <!-- End .col -->
                  <div class="col">
                    <div class="review-content">
                      <p>{{ response.text }}</p>
                    </div>
                    <!-- End .review-content -->
                  </div>
                  <!-- End .col-auto -->
                </div>
                <!-- End .row -->
              </div>
              <!-- End .review -->
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>

    <div
      class="modal fade"
      id="reponse-comment-modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>

            <div class="form-box">
              <div class="form-tab">
                <ul class="nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="signin-tab"
                      data-toggle="tab"
                      href="#signin"
                      role="tab"
                      aria-controls="signin"
                      aria-selected="true"
                      >Rispondi al commento</a
                    >
                  </li>
                </ul>
                <div class="tab-content" id="tab-content-5">
                  <div
                    class="tab-pane fade show active"
                    id="signin"
                    role="tabpanel"
                    aria-labelledby="signin-tab"
                  >
                    <form @submit.prevent="sendresponsecomment">
                      <div class="form-group">
                        <label for="singin-email">Messaggio</label>
                        <textarea
                          class="form-control"
                          id="singin-email"
                          name="testo"
                          placeholder="Inserisci il messaggio"
                          v-model="formresponsecomment.text"
                          required
                        ></textarea>
                      </div>
                      <!-- End .form-group -->

                      <div
                        class="alert alert-danger"
                        v-if="errorsmessageResponse.text"
                      >
                        {{ errorsmessageResponse.text[0] }}
                      </div>

                      <div class="form-footer">
                        <button
                          type="submit"
                          class="btn btn-outline-primary-2 btn-order btn-block"
                        >
                          <span class="btn-text">Invia</span>
                          <span class="btn-hover-text"
                            >Pubblica la risposta</span
                          >
                        </button>
                      </div>
                      <!-- End .form-footer -->
                    </form>
                  </div>
                  <!-- .End .tab-pane -->
                </div>
                <!-- End .tab-content -->
              </div>
              <!-- End .form-tab -->
            </div>
            <!-- End .form-box -->
          </div>
          <!-- End .modal-body -->
        </div>
        <!-- End .modal-content -->
      </div>
      <!-- End .modal-dialog -->
    </div>

    <div v-for="comment in comments" :key="comment.id">
      <div v-if="comment.attachments.length > 0">
        <ModalAttachmentsComponent
          :attachments="comment.attachments"
          :id="'modal-component-attachments-comments' + comment.id"
        ></ModalAttachmentsComponent>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import ModalAttachmentsComponent from "./ModalAttachmentsComponent.vue";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "CommentListComponent",
  props: [
    "activity_id",
    "successmessagecomment",
    "comments",
    "loadComments",
    "comment_permission",
    "model",
  ],
  components: {
    //SwiperComponents,
    ModalAttachmentsComponent,
  },
  setup() {
    return {};
  },
  data() {
    return {
      formresponsecomment: {
        comment_id: 0,
        text: "",
      },
      errorsmessageResponse: [],
      formcomment: {
        activity_id: 0,
        text: "",
      },
      modalAttachments: [],
      errors: [],
      classComment: {
        name: "col-sm-2",
        text: "col-sm-10",
      },
    };
  },
  mounted() {
    if (this.model && this.model == "meeting") {
      this.classComment.name = "col-sm-12";
      this.classComment.text = "col-sm-12";
    } else if (this.model && this.model == "meeting-old") {
      this.classComment.name = "col-sm-12";
      this.classComment.text = "col-sm-12";
    }
    /*
      $(this).appendTo("body");
    });*/
  },
  methods: {
    openModalResponse(commentId) {
      this.formresponsecomment.comment_id = commentId;
      $("#reponse-comment-modal").modal("show");
    },
    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    showModalAttachments(id) {
      $("#modal-component-attachments-comments" + id).modal("show");
    },

    async sendresponsecomment() {
      await httpauth
        .post("/comment-response/store", this.formresponsecomment)
        .then((response) => {
          $("#reponse-comment-modal").modal("hide");
          this.$emit("setSuccessMessage", response.data.message);
          this.formresponsecomment.text = "";
          this.loadComments();
        })
        .then((error) => {
          console.log(error);
        });
    },
  },
};
</script>